import React from "react";
import PropTypes from "prop-types";
import injectSheet from "react-jss";

import Main from "../components/Main";
import Article from "../components/Main/Article";
import PageHeader from "../components/Page/PageHeader";
import Content from "../components/Main/Content";
import Footer from "../components/Footer/Footer";

import Link from "gatsby-link";

const styles = theme => ({});

const Support = () => {
  return (
    <Main>
      <Article>
        <PageHeader title="Terms of Use / Privacy Policy" />
        <Content>
          <br />
          <br />
          <a href="https://projectsurfhelmet.com/Terms-and-Conditions.pdf" target="_blank">
            Terms and conditions
          </a>
          <br />
          <br />
          <Link to="/privacy/">Privacy Policy</Link>
          <br />
          <br />
          <br />
          <br />
        </Content>
        {/*<Form />*/}
      </Article>
      <Footer />
    </Main>
  );
};

Support.propTypes = {
  classes: PropTypes.object.isRequired
};

export default injectSheet(styles)(Support);



// WEBPACK FOOTER //
// ./src/pages/terms.js